import { Autocomplete, Chip, TextField } from "@mui/material";
import * as React from "react";

export default function MultipleSelect({
  er = "",
  disabled = false,
  label,
  name1,
  value1 = [],
  names = [],
  onChange,
}) {
  const getAllIds = () => names.filter(n => n.id !== 0).map(n => n.id);


  // State for selected option objects and their IDs
  const [selectedOptions, setSelectedOptions] = React.useState([]);
  const [selectedId, setSelectedId] = React.useState([]);


  const handleChange = (event, newValue, reason, details) => {
    let newValueWithFilter = newValue.filter(item => item !== undefined);

    const allIds = getAllIds();
    const allOption = names.find(n => n.id === 0);


    // If user selects "All"
    if (
      newValueWithFilter.some(option => option.id === 0) &&
      selectedId.length !== allIds.length
    ) {
      setSelectedOptions([allOption]);
      setSelectedId(allIds);
      onChange(allIds, name1);
      return;
    }



    // If user deselects "All" itself, clear all
    if (
      reason === "removeOption" &&
      details?.option?.id === 0
    ) {
      setSelectedOptions([]);
      setSelectedId([]);
      onChange([], name1);
      return;
    }



    // If user deselects any item after "All" was selected
    if (
      selectedId.length === allIds.length
      && details?.option?.id !== undefined
      && details?.option?.id !== 0
    ) {
      // Remove the deselected id from allIds
      const newIds = allIds.filter(id => id !== details.option.id);
      const alreadySelectedOptions = names.filter(n => newIds.includes(n.id));
      setSelectedOptions(alreadySelectedOptions);
      setSelectedId(newIds);
      onChange(newIds, name1);
      return;
    }



    // Normal selection logic
    const selectedIds = newValueWithFilter.map(option => option.id);
    setSelectedOptions(newValueWithFilter);
    setSelectedId(selectedIds);
    onChange(selectedIds, name1);
  };



  /*Working Code*/
  React.useEffect(() => {
    const isFlag = (value1 !== selectedId && names.length !== 0) || selectedOptions.length == 0;


    if (names.length == 0 && value1.length == 0 && selectedId.length !== 0) {
      setSelectedOptions([]);
      setSelectedId([]);
      return;
    }


    if (isFlag) {
      // If names exist and first item is not 0
      if (names.length !== 0 && names[0].id !== 0) {

        const filteredData = value1
          .map(id => names.find(row => row.id === id))

        setSelectedOptions(filteredData);
        setSelectedId(value1);
      } else if (names.length !== 0) {

        const expectedLength = names.length - 1;

        const valueArray = Array.isArray(value1) ? value1 : [value1];


        if (valueArray.length === expectedLength) {
          setSelectedOptions([names[0]]);
          setSelectedId(0);
        } else {
          const filteredData = valueArray
            .map(id => names.find(row => row.id == id))
            .filter(Boolean);

          setSelectedOptions(filteredData);
          setSelectedId(valueArray);
        }
      }
    }
  }, [value1, names]);

  return (
    <Autocomplete
      multiple
      options={names}
      isOptionEqualToValue={(option, value) => {
        if (!option || !value) return false;
        return option.id === value.id;
      }}
      size="small"
      getOptionLabel={option => option?.name || ""}
      value={selectedOptions}
      disableCloseOnSelect
      onChange={handleChange}
      renderInput={params => (
        <TextField
          {...params}
          variant="standard"
          placeholder="Search..."
          error={er !== "" ? true : false}
          margin="0px"
          helperText={er !== "" ? er : " "}
        />
      )}
      renderTags={(value, getTagProps) =>
        value
          .filter(option => option !== undefined && option !== null)
          .map((option, index) => (
            <Chip
              key={option?.id}
              label={option?.name}
              size="small"
              {...getTagProps({ index })}
            />
          ))
      }
    />
  );
};